import React from 'react';
import { Grid } from '@mui/material';
import MCPServerListPanel from './MCPServerListPanel';
import MCPServerDetailPanel from './MCPServerDetailPanel';
import MCPServerEditorDialog from './MCPServerEditorDialog';
import MCPCapabilityEvaluationDialog from './MCPCapabilityEvaluationDialog';
import { useMcpRegistry } from '../../../../hooks/useMcpRegistry';
import { McpMergedCapability } from '../../../../types/aiTypes';

const MCPServersView: React.FC = () => {
  const registry = useMcpRegistry();

  const [evaluationOpen, setEvaluationOpen] = React.useState(false);
  const [evaluationCapability, setEvaluationCapability] =
    React.useState<McpMergedCapability | null>(null);

  const openEvaluation = (capability: McpMergedCapability) => {
    registry.setSelectedCapability(capability);
    setEvaluationCapability(capability);
    setEvaluationOpen(true);
  };

  const closeEvaluation = () => {
    setEvaluationOpen(false);
    setEvaluationCapability(null);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} xl={4}>
        <MCPServerListPanel
          servers={registry.servers}
          loading={registry.serversLoading}
          selectedServerId={registry.selectedServerId}
          onSelect={registry.selectServer}
          onAdd={registry.openCreate}
          onEdit={registry.openEdit}
          onDelete={registry.removeServer}
          onRefresh={registry.refreshAll}
        />
      </Grid>

      <Grid item xs={12} xl={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MCPServerDetailPanel
              server={registry.server}
              authConfigs={registry.authConfigs}
              health={registry.latestHealth}
              syncState={registry.syncState}
              capabilities={registry.capabilities}
              selectedCapability={registry.selectedCapability}
              onSelectCapability={registry.setSelectedCapability}
              onEvaluateCapability={openEvaluation}
              onPromoteDiscovered={registry.promoteDiscovered}
              promotingCapability={registry.promoting}
              onRefresh={registry.refreshAll}
              onSync={registry.selectedServerId ? registry.syncSelected : undefined}
              syncing={registry.syncing}
            />
          </Grid>
        </Grid>
      </Grid>

      <MCPServerEditorDialog
        open={registry.editorOpen}
        initialValue={registry.editorInitialValue}
        submitting={registry.saving}
        onClose={registry.closeEditor}
        onSubmit={registry.saveServer}
      />

      <MCPCapabilityEvaluationDialog
        open={evaluationOpen}
        capability={evaluationCapability}
        selectedServerId={registry.selectedServerId}
        onClose={closeEvaluation}
        onEvaluate={registry.evaluateCapability.mutateAsync}
        evaluating={registry.evaluateCapability.isPending}
      />
    </Grid>
  );
};

export default MCPServersView;